import {Roster} from "@/api/dto/dto";
import {Address, ExtendedDemographics, InsurancePlan} from "@/api/dto/client-profile";

export type Encounter = {
  id: number,
  external_id: string,
  data_type: string,
}

export type DischargeDisposition = {
  id: number,
  dispositionSynonym: string,
  type: string,
  code: string,
  facilityDispositionType?: string | null
}

export type Insurance = {
  insurerId: number,
  insurancePlanId: number,
  companyName?: string,
  otherCompanyName?: string | null,
  code: string,
  value: string | null
}

export type SearchFacility = {
  id: number,
  parentId?: number  | null,
  name: string,
  type: string,
  timezone?: string | null,
  state?: string | null,
  city?: string | null,
  parentName?: string | null,
}

export type UpdateStatusDeceasedJson = {
  encounterId: number,
  options: {
    date: Date
  }
}

export type UpdateDeceasedJson = {
  date: Date
}

export type UpdateStatusDischargeJson = {
  encounterId: number,
  options: {
    date: Date,
    disposition: {
      location: {
        facility?: {
          id: number,
          facilityName: string,
        },
        secondaryFacility?: {
          id: number,
          facilityName: string
        },
        locationDescription: string
      },
      dispositionType: {
        id: number,
        itemCode: string
      }
    }
  }
}

export type UpdateDischargeJson = {
  date: Date,
  disposition: {
    location: {
      facility?: {
        id: number,
        facilityName: string,
      },
      secondaryFacility?: {
        id: number,
        facilityName: string
      },
      locationDescription: string
    },
    dispositionType: {
      id: number,
      itemCode: string
    }
}
}

export type UpdateStatusPayorChangeJson = {
  encounterId: number,
  options: {
    date: Date,
    payor: {
      id: number,
    }
  }
}

export type UpdatePayorChangeJson = {
  date: Date,
  payor: InsurancePlan
}

export type UpdateStatusTransferJson = {
  encounterId: number,
  options: {
    date: Date,
    setting: string,
    selectedInsurancePlan: {
      id: number
    }
  }
}

export type UpdateTransferJson = {
  date: Date,
  setting: string,
  selectedInsurancePlan: {
    id: number,
  },
}

export type AdmitEncounterJson = {
  publicPatientId: string,
  creatorGroupId: number,
  admit: {
    date: string,
    admittedFromFacilityId?: number,
    admittedFromFacilityName?: string,
    setting: string,
    selectedInsurancePlan: {
      id: number,
    },
  }
}

export type UpdateAdmitJson = {
  date: Date,
  admittedFromFacilityId: number,
  admittedFromFacilityName: string,
  setting: string,
  selectedInsurancePlan: {
    id: number,
  },
}

export interface EncounterClient {
  publicPatientId: string;
  patientId?: string;
  clientId?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  dateOfBirth?: string;
  gender?: string;
  phone?: string;
  phoneType?: string;
  type?: string,
  address?: Address;
  ssn?: string;
  roster?: Roster;
  extendedDemographics?: ExtendedDemographics
  insurancePlans?: InsurancePlan[],
  currentPayor?: InsurancePlan,
  currentlyAdmitted?: boolean;
  currentPingEncounter?: {
    admittedFromLocation?: string;
  };
}

export interface EncounterDeleteResponse {
  pingsResponse: string;
  patientRemoved: boolean;
}

export enum DeAgencyEvent {
  ADMIT = 'admit',
  DISCHARGE = 'discharge',
}

// The API leaves out an agency that isn't stored, rather than sending null.
export interface DeAgencies {
  admissionAgency?: string | null;
  dischargeAgency?: string | null;
}
